import { Injectable, effect, inject } from '@angular/core';
import { Subject, of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { Context } from 'src/app/controls/advanced-gridview/models/context';
import { FilterInfos } from 'src/app/controls/advanced-gridview/models/filter-infos';
import { Results } from 'src/app/controls/advanced-gridview/models/results-T';
import { SortInfos } from 'src/app/controls/advanced-gridview/models/sort-infos';
import { AdvancedService } from 'src/app/controls/advanced-gridview/services/advanced-service';
import { RestApiEventConfiguration } from 'src/app/models/RestApiCaller/configuration/rest-api-event-configuration';
import { ApiConfigurationState } from '../../models/api-configuration-state';

@Injectable()
export class EventService implements AdvancedService<RestApiEventConfiguration> {
    protected readonly apiConfigurationState = inject(ApiConfigurationState);

    private currentEventList: RestApiEventConfiguration[] = [];

    set eventsList(value: RestApiEventConfiguration[]) {
        console.log('EventService --> set eventsList');
        let apiConfiguration = this.apiConfigurationState.$apiConfiguration().createCopy();
        apiConfiguration.eventConfigurations = value;
        this.apiConfigurationState.$apiConfiguration.set(apiConfiguration);
    }

    constructor() {
        effect(
            () => {
                console.log('EnventService --> refresh');
                if (this.apiConfigurationState.$apiConfiguration() !== null && this.currentEventList !== this.apiConfigurationState.$apiConfiguration().eventConfigurations) {
                    this.needRefresh.next();
                }
                //}
            },
            { allowSignalWrites: true }
        );
    }

    public needRefresh: Subject<void> = new Subject();

    public List(
        context: Context,
        filters: FilterInfos[],
        generalFilters: FilterInfos[],
        sortInfos: SortInfos,
        pageNumber: number,
        pageSize: number
    ): Observable<Results<RestApiEventConfiguration>> {
        var res = new Results<RestApiEventConfiguration>();
        console.log('Liste les évènements : ', this.apiConfigurationState.$apiConfiguration().eventConfigurations);
        this.currentEventList = this.apiConfigurationState.$apiConfiguration().eventConfigurations;
        res.value = this.currentEventList;
        res.totalCount = res.value.length;
        res.resultCount = res.value.length;

        return of(res);
    }

    Export(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos): Observable<Blob> {
        const blob = new Blob();
        return of(blob);
    }
}
